import { createSlice } from "@reduxjs/toolkit";
import { updateAiCampaignAPI } from "../../services/updateAiCampaign";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateAiCampaignSlice = createSlice({
  name: "updateAiCampaign",
  initialState: data,
  reducers: {
    updateAiCampaignInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    updateAiCampaignInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      const p = action.payload;
      state.message =
        typeof p?.message === "string" ? p.message : "Campaign updated successfully";
      state.error = "";
    },
    updateAiCampaignInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      const p = action.payload;
      state.error =
        typeof p === "string"
          ? p
          : p?.message != null
            ? String(p.message)
            : Array.isArray(p?.errors)
              ? p.errors.map(String).join(" ")
              : p != null
                ? String(p)
                : "Something went wrong";
      state.data = null;
    },
    updateAiCampaignInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateAiCampaignHandler = (payload) => async (dispatch) => {
  try {
    dispatch(updateAiCampaignAction.updateAiCampaignInfo());
    const response = await updateAiCampaignAPI(payload);
    dispatch(updateAiCampaignAction.updateAiCampaignInfoSuccess(response));
  } catch (e) {
    const raw =
      typeof e === "string"
        ? e
        : e?.response?.data?.message ?? e?.message ?? e;
    dispatch(updateAiCampaignAction.updateAiCampaignInfoFailure(raw));
  }
};

export default updateAiCampaignSlice.reducer;
export const updateAiCampaignAction = updateAiCampaignSlice.actions;
